import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useParams } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient } from '../helpers/Helpers.js';

export default function ImpostazioniDettagli() {

    const { id } = useParams();
    const client = getWebClient();
    const navigate = useNavigate();

    const [labels, setLabels] = useState();
    const [model, setModel] = useState({ chiave: '', valore: '' });
    const [note, setNote] = useState('');

    useEffect(() => {

        setLabels({
            "title": "Dettagli dell'impostazione",
            "submitButtonText": "Salva le modifiche",
        });

        const impostazioniGetPromise = client.get(`/api/impostazioni/${id}`).then((response) => {
            setModel(response.data);
            if (response.data.chiave === 'ModalitaVisualizzazione') {
                setNote(
                    <div>
                        Valori ammessi (click per modificare):<br /><br />
                        <span className="set-modalita-visualizzazione" onClick={() => setModalitaVisualizzazione('BLANK')}>BLANK</span> - L'app non viene visualizzata<br />
                        <span className="set-modalita-visualizzazione" onClick={() => setModalitaVisualizzazione('LOCKED')}>LOCKED</span> - Viene visualizzata unicamente la pagina di login, non &egrave; possibile accedere<br />
                        <span className="set-modalita-visualizzazione" onClick={() => setModalitaVisualizzazione('EDITONLY')}>EDITONLY</span> - E' possibile unicamente modificare il proprio profilo<br />
                        <span className="set-modalita-visualizzazione" onClick={() => setModalitaVisualizzazione('RATEANDREADONLY')}>RATEANDREADONLY</span> - E' possibile unicamente visualizzare l'agenda e impostare le valutazioni (seller)<br />
                        <span className="set-modalita-visualizzazione" onClick={() => setModalitaVisualizzazione('FULL')}>FULL</span> - Tutte le funzionalit&agrave; dell'app sono attive<br />
                    </div>
                )
            }
        });

        Promise.all([impostazioniGetPromise]).catch(function (err) {
            console.log(err);
        });

    }, []);

    function setModalitaVisualizzazione(text) {
        setModel({ chiave: 'ModalitaVisualizzazione', valore: text });
    }

    if (labels === undefined || model === undefined) { return; }

    return (
        <>

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <h4>{labels.title}</h4>
            </div>

            <div className="container" style={{ marginBottom: 80 }}>

                <Formik

                    initialValues={model}
                    enableReinitialize="true"

                    validate={values => {

                        const errors = {};

                        document.getElementsByName('valore')[0].classList.remove("is-invalid")

                        if (!values.valore) {
                            errors.valore = <>Il campo Valore &egrave; richiesto</>;
                            document.getElementsByName('valore')[0].classList.add("is-invalid")
                        }

                        return errors;
                    }}

                    onSubmit={(values, { setSubmitting }) => {

                        if (id === 'new') {

                            client.post('/api/impostazioni', values)
                                .then(function (response) {
                                    navigate("/impostazioni");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        } else {

                            client.put('/api/impostazioni', values)
                                .then(function (response) {
                                    navigate("/impostazioni");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        }
                    }}
                >

                    {({ isSubmitting }) => (

                        <Form>

                            <div className="row mb-3">
                                <label htmlFor="chiave" className="col-sm-2 col-form-label">Chiave</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="chiave" id="chiave" readOnly="readonly" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Valore</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="valore" id="valore" />
                                    <ErrorMessage className="invalid-feedback" name="valore" component="div" />
                                    <br></br>
                                    <div>{note}</div>
                                </div>
                            </div>

                            <button className="btn btn-primary" style={{ marginTop: 40 }} type="submit" disabled={isSubmitting}>{labels.submitButtonText}</button>
                            
                        </Form>

                    )}

                </Formik>

            </div>

        </>
    )
}
